import _toConsumableArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _slot;

import { MediaTextDisplay } from "./media-text-display.js";
import { globalThis } from "./utils/server-safe-globals.js";
import { formatTime } from "./utils/time.js";
import { MediaUIAttributes } from "./constants.js";
import { getNumericAttr, setNumericAttr } from "./utils/element-utils.js";

var MediaPreviewTimeDisplay = /*#__PURE__*/function (_MediaTextDisplay) {
  _inherits(MediaPreviewTimeDisplay, _MediaTextDisplay);

  var _super = _createSuper(MediaPreviewTimeDisplay);

  function MediaPreviewTimeDisplay() {
    var _this;

    _classCallCheck(this, MediaPreviewTimeDisplay);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _slot, void 0);

    __privateSet(_assertThisInitialized(_this), _slot, _this.shadowRoot.querySelector("slot"));

    __privateGet(_assertThisInitialized(_this), _slot).textContent = formatTime(0);
    return _this;
  }

  _createClass(MediaPreviewTimeDisplay, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (attrName === MediaUIAttributes.MEDIA_PREVIEW_TIME && newValue != null) {
        __privateGet(this, _slot).textContent = formatTime(newValue);
      }

      _get(_getPrototypeOf(MediaPreviewTimeDisplay.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);
    }
  }, {
    key: "mediaPreviewTime",
    get: function get() {
      return getNumericAttr(this, MediaUIAttributes.MEDIA_PREVIEW_TIME);
    },
    set: function set(value) {
      setNumericAttr(this, MediaUIAttributes.MEDIA_PREVIEW_TIME, value);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaPreviewTimeDisplay), "observedAttributes", this)), [MediaUIAttributes.MEDIA_PREVIEW_TIME]);
    }
  }]);

  return MediaPreviewTimeDisplay;
}(MediaTextDisplay);

_slot = new WeakMap();

if (!globalThis.customElements.get("media-preview-time-display")) {
  globalThis.customElements.define("media-preview-time-display", MediaPreviewTimeDisplay);
}

var media_preview_time_display_default = MediaPreviewTimeDisplay;
export { media_preview_time_display_default as default };